export const MAX_IMAGE_PROMPT_LENGTH = 3000
export const MAX_NAME_LENGTH = 50
export const MAX_LONG_DESCRIBE_LENGTH = 1000000
export const MAX_SHORT_DESCRIBE_LENGTH = 100000
export const MIN_GREETING_LENGTH = 3
export const MAX_GREETING_LENGTH = 20000
export const MAX_SCENARIO_LENGTH = 3000
export const MAX_BASE_VOICES = 3
export const MAX_DIALOG_STYLE_ROUNDS = 100
export const MAX_DIALOG_STYLE_LENGTH = 20000
export const MAX_REPLY_REQUIREMENT_LENGTH = 2000
export const MAX_USER_MESSAGE_LENGTH = 10000
export const CHARACTER_MEMORY_MAX_DESCRIPTION = 500
export const MAX_OPTIMIZATION_CODE_LENGTH = 50000
export const UPLOAD_IMG_CROP_RATIO = 9 / 16
